import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import currencyFormatter from '@tcs/common/utils/formatCurrency';
import { useStyles } from '@tcs/client-portal-common/components/molecules/Table/style';
interface CellProps {
  value: number;
}

const AmountCell = ({ value }: CellProps) => {
  const classes = useStyles({});

  return (
    <BaseCell
      value={currencyFormatter(value)}
      isPrivate
      align="left"
      className={classes.alignNumbers}
    />
  );
};

export default AmountCell;
